import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.NaringNaringsbyggOgEiendeler,
        tekst: 'Næringsbygg og eiendeler',
    },
    {
        id: KategoriSvarId.Naring,
        tekst: 'Annen næringsskade',
    },
    {
        id: KategoriSvarId.RettshjelpNaring,
        tekst: 'Rettshjelp',
    },
    {
        id: KategoriSvarId.Ansvar,
        tekst: 'Ansvar',
    },
];

export const Naring = () => {
    const { url } = useConfig().links.naringlandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.Naring) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Naring));
        } else if (svarId === KategoriSvarId.NaringNaringsbyggOgEiendeler) {
            navigate(urler().naringNaringsbyggOgEiendelerUrl);
        } else if (svarId === KategoriSvarId.RettshjelpNaring) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Rettshjelp));
        } else if (svarId === KategoriSvarId.Ansvar) {
            navigate(urler().ansvarLandbrukNaringUrl);
        }
    };

    return (
        <GruppeLandingsside
            title="Næring"
            onNext={onNext}
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            kategoriId="naring"
            radioButtonsLabel="Hva gjelder det?"
        />
    );
};
